__turbopack_context__.v({
  "className": "open_sans_71403944-module__MtaT4a__className",
});
